(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('cart-discount-form')) {
    customElements.define(
      'cart-discount-form',
      class CartDiscountForm extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('.cart-discount__input');
          this.applyButton = this.querySelector('[data-apply-discount]');
          this.errorEl = this.querySelector('[data-discount-error]');
          this.sectionId = this.dataset.sectionId;
          this.errorText = this.dataset.errorText || 'Could not apply that code.';

          if (!this.applyButton) return;

          this.applyButton.addEventListener('click', () => this.applyDiscount());
          this.input.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              this.applyDiscount();
            }
          });
        }

        get root() {
          return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        }

        async applyDiscount() {
          const code = this.input.value.trim();
          if (!code) return;

          this.setLoading(true);
          this.hideError();

          try {
            await fetch(`${this.root}discount/${encodeURIComponent(code)}`, {
              method: 'GET',
              headers: { Accept: 'text/html' },
            });

            await this.refreshDrawer();
          } catch (error) {
            this.showError();
            this.setLoading(false);
          }
        }

        async refreshDrawer() {
          const response = await fetch(`${this.root}?sections=${this.sectionId}`);
          const data = await response.json();
          const parsed = new DOMParser().parseFromString(data[this.sectionId], 'text/html');

          const newDrawer = parsed.querySelector('cart-drawer');
          const currentDrawer = document.getElementById('cart-drawer');

          if (newDrawer && currentDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
          } else {
            window.location.reload();
          }
        }

        setLoading(isLoading) {
          this.applyButton.disabled = isLoading;
          this.input.disabled = isLoading;
        }

        showError() {
          this.errorEl.textContent = this.errorText;
          this.errorEl.hidden = false;
        }

        hideError() {
          this.errorEl.hidden = true;
        }
      },
    );
  }

  // ---- Countdown timer + age-verification gate + cross-sell direct add ----
  // Lives in so it binds once; a MutationObserver
  // re-initialises after the drawer re-renders (e.g. discount apply / quantity change).
  // Age gate targets the native theme checkout button via button[name="checkout"].
  (function () {
    let countdownTimer = null;

    function getCheckoutBtn() {
      return document.querySelector('#cart-drawer button[name="checkout"]');
    }

    function initCountdown() {
      const display = document.getElementById('cart-countdown-display');
      if (!display) {
        if (countdownTimer) {
          clearInterval(countdownTimer);
          countdownTimer = null;
        }
        return;
      }
      const minutes = parseInt(display.getAttribute('data-minutes'), 10) || 10;
      const storageKey = 'cart_drawer_countdown_end';
      let endTime = parseInt(sessionStorage.getItem(storageKey), 10);
      if (!endTime || isNaN(endTime) || endTime < Date.now()) {
        endTime = Date.now() + minutes * 60 * 1000;
        sessionStorage.setItem(storageKey, String(endTime));
      }
      if (countdownTimer) clearInterval(countdownTimer);
      const tick = () => {
        const d = document.getElementById('cart-countdown-display');
        if (!d) {
          clearInterval(countdownTimer);
          countdownTimer = null;
          return;
        }
        const remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
        const m = Math.floor(remaining / 60);
        const s = remaining % 60;
        d.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
        if (remaining <= 0) {
          clearInterval(countdownTimer);
          countdownTimer = null;
        }
      };
      tick();
      countdownTimer = setInterval(tick, 1000);
    }

    function initAgeGate() {
      const cb = document.getElementById('cart-age-verify');
      const btn = getCheckoutBtn();
      if (cb && btn) btn.disabled = !cb.checked;
    }

    function initEnhancements() {
      initCountdown();
      initAgeGate();
    }

    function boot() {
      initEnhancements();
      const drawer = document.getElementById('cart-drawer');
      if (drawer && !drawer.__enhObserver) {
        let raf;
        const obs = new MutationObserver(() => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(initEnhancements);
        });
        obs.observe(drawer, { childList: true, subtree: true });
        drawer.__enhObserver = obs;
      }
    }

    if (!window.__cartAgeGateBound) {
      window.__cartAgeGateBound = true;
      document.addEventListener('change', (e) => {
        if (e.target && e.target.id === 'cart-age-verify') {
          const btn = getCheckoutBtn();
          if (btn) btn.disabled = !e.target.checked;
        }
      });
    }

    // NOTE: Do NOT put Liquid tags inside this javascript block. Shopify serves it as a
    // static asset and does not render Liquid here, so a Liquid tag is emitted literally and
    // its percent sign breaks the whole compiled scripts.js bundle (every custom element in it
    // then fails to register). The cross-sell buttons are already gated by alp_disable_sales in
    // the HTML above, so binding this delegated handler unconditionally is safe.
    if (!window.__cartXsellBound) {
      window.__cartXsellBound = true;
      document.addEventListener('click', async function (e) {
        const btn = e.target.closest('[data-cross-sell-add]');
        if (!btn || btn.disabled) return;
        e.preventDefault();

        const variantId = btn.getAttribute('data-variant-id');
        const sectionId = btn.getAttribute('data-section-id');
        if (!variantId) return;

        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const label = btn.textContent;
        btn.disabled = true;

        try {
          await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
          });

          const res = await fetch(root + '?sections=' + sectionId);
          const data = await res.json();
          const parsed = new DOMParser().parseFromString(data[sectionId], 'text/html');
          const newDrawer = parsed.querySelector('cart-drawer');
          const currentDrawer = document.getElementById('cart-drawer');

          if (newDrawer && currentDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          } else {
            window.location.reload();
          }
        } catch (err) {
          btn.disabled = false;
          btn.textContent = label;
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();
  // ---- Auto-apply discount code (section setting "auto_apply_discount_code") ----
  // Whenever the cart has items and the configured code is not yet applied, applies it via
  // the Cart AJAX API (/cart/update.js { discount }) and re-renders the drawer so the discount
  // badge and totals show immediately. If Shopify rejects the code (not created / inactive /
  // not applicable) we stop retrying for the rest of the browser session to avoid request loops.
  (function () {
    var FAILED_KEY = 'cart_auto_discount_failed';
    var busy = false;
    var queued = false;

    function root() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function getConfig() {
      var drawer = document.getElementById('cart-drawer');
      if (!drawer) return null;
      var code = (drawer.getAttribute('data-auto-discount') || '').trim();
      if (!code) return null;
      return { code: code, sectionId: drawer.getAttribute('data-section-id') };
    }

    function hasCode(cart, code) {
      var codes = (cart && cart.discount_codes) || [];
      return codes.some(function (dc) {
        return dc && dc.applicable !== false && String(dc.code).toUpperCase() === code.toUpperCase();
      });
    }

    function readStorage(key) {
      try {
        return sessionStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }
    function writeStorage(key, value) {
      try {
        sessionStorage.setItem(key, value);
      } catch (e) {
        /* private mode etc. */
      }
    }

    async function fetchCart() {
      var res = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } });
      return res.json();
    }

    async function rerenderDrawer(sectionId) {
      if (!sectionId) return;
      var res = await fetch(root() + '?sections=' + sectionId);
      var data = await res.json();
      var parsed = new DOMParser().parseFromString(data[sectionId], 'text/html');
      var newDrawer = parsed.querySelector('cart-drawer');
      var currentDrawer = document.getElementById('cart-drawer');
      if (newDrawer && currentDrawer) {
        currentDrawer.className = newDrawer.className;
        currentDrawer.innerHTML = newDrawer.innerHTML;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    }

    async function run(event) {
      var cfg = getConfig();
      if (!cfg) return;
      if (readStorage(FAILED_KEY) === cfg.code.toUpperCase()) return;

      if (busy) {
        queued = true;
        return;
      }
      busy = true;

      try {
        var cart = event && event.detail && event.detail.cart;
        if (!cart || typeof cart.item_count !== 'number') cart = await fetchCart();

        if (cart.item_count > 0 && !hasCode(cart, cfg.code)) {
          var res = await fetch(root() + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: cfg.code }),
          });
          var updated = res.ok ? await res.json() : null;

          if (updated && hasCode(updated, cfg.code)) {
            await rerenderDrawer(cfg.sectionId);
          } else {
            writeStorage(FAILED_KEY, cfg.code.toUpperCase());
            if (window.console) console.warn('[cart-auto-discount] Code not applicable:', cfg.code);
          }
        }
      } catch (e) {
        if (window.console) console.warn('[cart-auto-discount]', e);
      } finally {
        busy = false;
        if (queued) {
          queued = false;
          run();
        }
      }
    }

    if (!window.__cartAutoDiscountBound) {
      window.__cartAutoDiscountBound = true;
      document.addEventListener('cart:change', run);
      document.addEventListener('cart:refresh', function () {
        run();
      });
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          run();
        });
      } else {
        run();
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
